/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CalendarInventoryConflictMode = {
    Exclusive: 'exclusive',
    Shared: 'shared',
    Warning: 'warning'
} as const;
export type CalendarInventoryConflictMode = typeof CalendarInventoryConflictMode[keyof typeof CalendarInventoryConflictMode];

